/* eslint-disable */
export const lifeCycleStatusLookup: any[] = [
  {
    'option': '',
    'title': '-',
    'hint_detail': ''
  },
  {
    'option': '0',
    'title': 'Proposed',
    'hint_detail': '(Internal Use) - Part is in the process of being released. Required fields are not completed to release it for initial orders.'
  },
  {
    'option': '1',
    'title': 'Released',
    'hint_detail': '(Internal Use) - New part notification is sent to inventory control and research. All required information has been completed.'
  },
  {
    'option': '2',
    'title': 'Available to Order',
    'hint_detail': 'Part is released to customers for ordering.'
  },
  {
    'option': '3',
    'title': 'Electronically Announced',
    'hint_detail': 'Part has been announced to customers via electronic data files. Part is active but needs paper announcement.'
  },
  {
    'option': '4',
    'title': 'Announced',
    'hint_detail': 'Part has been announced to customers on a paper â€œNew Number Announcementâ€. Part is active.'
  },
  {
    'option': '5',
    'title': 'Temporarily Unavailable',
    'hint_detail': 'Part is suspended from shipment due to lack of availability or a hold on production.'
  },
  {
    'option': '6',
    'title': 'Renumbered',
    'hint_detail': 'Existing inventory of this part should be renumbered to the surviving part number.'
  },
  {
    'option': '7',
    'title': 'Superseded',
    'hint_detail': 'Part is being replaced by the surviving part number.'
  },
  {
    'option': '8',
    'title': 'Discontinued',
    'hint_detail': 'Part is being removed from the product line.'
  },
  {
    'option': '9',
    'title': 'Obsolete',
    'hint_detail': 'Obsolescence protection has expired on this part. It will no longer appear in catalogs, price lists.'
  },
  {
    'option': 'A',
    'title': 'Available only while supplies last',
    'hint_detail': 'Available only while supplies last'
  }
];

export const nationalPopularityCodeLookup: any[] = [
  {
    'option': '',
    'title': '-'
  },
  {
    'option': 'A',
    'title': 'Top 60% of Product group sales value (units x $, hits, etc.)'
  },
  {
    'option': 'B',
    'title': 'Next 20% of Product group sales value'
  },
  {
    'option': 'C',
    'title': 'Next 15% of product group sales Value'
  },
  {
    'option': 'D',
    'title': 'Last 5% of product group sales value'
  },
  {
    'option': 'N',
    'title': 'New item 3 months, 6 months, etc.'
  },
  {
    'option': 'W',
    'title': 'Non-stock item'
  },
  {
    'option': 'O',
    'title': 'Obsolete'
  },
  {
    'option': 'S',
    'title': 'Superseded'
  }
];

export const uomLookup: any = [
  { 'option': '', 'title': '-' },
  { 'option': 'OZ', 'title': 'Ounces' },
  { 'option': 'AS', 'title': 'Assortment' },
  { 'option': 'BG', 'title': 'Bag' },
  { 'option': 'BK', 'title': 'Book' },
  { 'option': 'BO', 'title': 'Bottle' },
  { 'option': 'BX', 'title': 'Box' },
  { 'option': 'BC', 'title': 'Bucket' },
  { 'option': 'BD', 'title': 'Bundle' },
  { 'option': 'CN', 'title': 'Can' },
  { 'option': 'CG', 'title': 'Card' },
  { 'option': 'CT', 'title': 'Carton' },
  { 'option': 'CQ', 'title': 'Cartridge' },
  { 'option': 'CA', 'title': 'Case' },
  { 'option': 'FN', 'title': 'Clamshell' },
  { 'option': 'CX', 'title': 'Coil' },
  { 'option': 'CH', 'title': 'Container' },
  { 'option': 'CP', 'title': 'Crate' },
  { 'option': 'DZ', 'title': 'Dozen' },
  { 'option': 'DR', 'title': 'Drum' },
  { 'option': 'EA', 'title': 'Each' },
  { 'option': 'EV', 'title': 'Envelope' },
  { 'option': 'FT', 'title': 'Foot' },
  { 'option': 'GA', 'title': 'Gallon' },
  { 'option': 'HU', 'title': 'Hundred' },
  { 'option': 'HC', 'title': 'Hundred count' },
  { 'option': 'JR', 'title': 'Jar' },
  { 'option': 'KE', 'title': 'Keg' },
  { 'option': 'KG', 'title': 'Kilogram' },
  { 'option': 'KT', 'title': 'Kit' },
  { 'option': 'LT', 'title': 'Liter' },
  { 'option': 'MR', 'title': 'Meter' },
  { 'option': 'PH', 'title': 'Pack (PAK)' },
  { 'option': 'PK', 'title': 'Package' },
  { 'option': 'PA', 'title': 'Pail' },
  { 'option': 'PR', 'title': 'Pair' },
  { 'option': 'PF', 'title': 'Pallet' },
  { 'option': 'PL', 'title': 'Pallet unit load' },
  { 'option': 'PC', 'title': 'Piece' },
  { 'option': 'PT', 'title': 'Pint' },
  { 'option': 'LB', 'title': 'Pound' },
  { 'option': 'QT', 'title': 'Quart' },
  { 'option': 'RE', 'title': 'Reel' },
  { 'option': 'RD', 'title': 'Rod' },
  { 'option': 'RL', 'title': 'Roll' },
  { 'option': 'ST', 'title': 'Set' },
  { 'option': 'SH', 'title': 'Sheet' },
  { 'option': 'SL', 'title': 'Sleeve' },
  { 'option': 'SO', 'title': 'Spool' },
  { 'option': '15', 'title': 'Stick' },
  { 'option': 'TH', 'title': 'Thousand' },
  { 'option': 'TY', 'title': 'Tray' },
  { 'option': 'TB', 'title': 'Tube' },
  { 'option': 'OP', 'title': 'Two pack' },
];

export const languageLookup: any[] = [{
  'option': 'EN',
  'title': 'English'
},
{
  'option': 'ES',
  'title': 'Spanish'
},
{
  'option': 'FR',
  'title': 'French'
}];

export const packageTypeLookup = [{
  option: 'EA',
  title: 'Smallest pack (consumer level)',
}, {
  option: 'PK',
  title: 'The shippable inner package',
}, {
  option: 'BX',
  title: 'Inner pack (non-shippable)',
}, {
  option: 'CA',
  title: 'Case',
}, {
  option: 'PL',
  title: 'Pallet',
}];

export const whmisCodeLookup: any[] = [
  {
    'option': '',
    'title': '-'
  },
  {
    "option": "A",
    "title": "Compressed gas"
  },
  {
    "option": "B.1",
    "title": "Flammable gas"
  },
  {
    "option": "B.2",
    "title": "Flammable liquid"
  },
  {
    "option": "B.3",
    "title": "Combustible liquid"
  },
  {
    "option": "B.4",
    "title": "Flammable solid"
  },
  {
    "option": "B.5",
    "title": "Flammable aerosol"
  },
  {
    "option": "B.6",
    "title": "Reactive flammable"
  },
  {
    "option": "C",
    "title": "Oxidizing material"
  },
  {
    "option": "D.1.A",
    "title": "Immediate toxic effects (D1A)"
  },
  {
    "option": "D.1.B",
    "title": "Immediate toxic effects (D1B)"
  },
  {
    "option": "D.2.A",
    "title": "Other Toxic Effects"
  },
  {
    "option": "D.2.B",
    "title": "Toxic material"
  },
  {
    "option": "D.3.B",
    "title": "Biohazard material"
  },
  {
    "option": "E",
    "title": "Corrosive material"
  },
  {
    "option": "F",
    "title": "Dangerous reactive"
  }
];
/* eslint-enable */
